import React from "react";

function formatK(value) {
  if (value < 1000) return value.toString();

  // Division en milliers
  const inK = value / 1000;

  // Troncature à 1 décimale
  const truncated = Math.floor(inK * 10) / 10;

  return truncated + "k";
}

function TeamCard({ player }) {
  return (
    <div className="team-stats">
      <TeamCardInner player={player} />
    </div>
  );
}


function TeamCardInner({ player }) {
    // Pourcentage gold
    var blueGoldPercent = Math.round((player.blueTeam.totalGold / (player.blueTeam.totalGold + player.redTeam.totalGold)) * 100);
    var redGoldPercent = Math.round((player.redTeam.totalGold / (player.blueTeam.totalGold + player.redTeam.totalGold)) * 100);

    // Différence team gold
    var teamGoldDiff = Math.abs(player.blueTeam.totalGold - player.redTeam.totalGold);

    // K/D/A team
    var blue_kills=0;
    var blue_deaths=0;
    var blue_assists=0;

    var red_kills=0;
    var red_deaths=0;
    var red_assists=0;

    player.blueTeam.participants.forEach(element => {
        blue_kills+=element.kills;
        blue_assists+=element.assists;
        blue_deaths+=element.deaths;
    });

    player.redTeam.participants.forEach(element => {
        red_kills+=element.kills;
        red_assists+=element.assists;
        red_deaths+=element.deaths;
    });

    return (<nav>
            <div class="flex-wrap three-wrap team-name">
                <div class="left-team">
                    <p>{player.blueTeam.name}</p>
                </div>
                <div class="vs">
                    <p>vs</p>
                </div>
                <div class="right-team">
                    <p>{player.redTeam.name}</p>
                </div>
            </div>

            <div class="flex-wrap two-wrap">
                <div class="left-team team-kda">
                    <p>{blue_kills} / {blue_deaths} / {blue_assists}</p>
                </div>

                <div class="right-team team-kda">
                    <p>{red_kills} / {red_deaths} / {red_assists}</p>
                </div>

            </div>

            <div>
                <div class="team-gold-contain flex-wrap">
                    <div class="blue-team-gold" style={{width:`${blueGoldPercent}%`}}></div>
                    <div class="red-team-gold" style={{width:`${redGoldPercent}%`}}></div>
                </div>
            </div>

            <div class="flex-wrap three-wrap">
                <div class="left-team">
                    <p>{ formatK(player.blueTeam.totalGold) }</p>
                </div>
                <div class="vs">
                    <p>
                        <img src="gold_left.png" alt="left gold" className="goldArrow" style={{opacity: player.blueTeam.totalGold > player.redTeam.totalGold ? 1 : 0,}}/>
                        { formatK(teamGoldDiff) }
                        <img src="gold_right.png" alt="right gold" className="goldArrow" style={{opacity: player.redTeam.totalGold > player.blueTeam.totalGold ? 1 : 0,}}/>
                    </p>
                </div>
                <div class="right-team">
                    <p>{ formatK(player.redTeam.totalGold) }</p>
                </div>
            </div>

            <div class="flex-wrap three-wrap">
                <div class="left-team">
                    {player.blueTeam.dragons.map((name, index) => (
                        <img src={"drakes/"+name+".png"} alt={name+"Drake"} />
                    ))}
                </div>
                <div class="vs">dragons</div>

                <div class="right-team">
                    {player.redTeam.dragons.map((name, index) => (
                        <img src={"drakes/"+name+".png"} alt={name+"Drake"} />
                    ))}
                </div>

            </div>

            <div class="flex-wrap two-wrap text-center">
                <div class="all-width">
                    <div class="flex-wrap three-wrap all-width">
                        <div>
                            <img src="inhibitor.png" alt="Inhibitors"/>
                        </div>
                        <div>
                            <img src="nashor.png" alt="Baron Nashor"/>
                        </div>
                        <div>
                            <img src="tower.png" alt="Towers"/>
                        </div>
                    </div>
                    <div class="flex-wrap three-wrap all-width">
                        <div>{ player.blueTeam.inhibitors }</div>
                        <div>{ player.blueTeam.barons }</div>
                        <div>{ player.blueTeam.towers }</div>
                    </div>
                </div>

                <div class="all-width">
                    <div class="flex-wrap three-wrap all-width">
                        <div>
                            <img src="inhibitor.png" alt="Inhibitors"/>
                        </div>
                        <div>
                            <img src="nashor.png" alt="Baron Nashor"/>
                        </div>
                        <div>
                            <img src="tower.png" alt="Towers"/>
                        </div>
                    </div>
                    <div class="flex-wrap three-wrap all-width">
                        <div>{ player.redTeam.inhibitors }</div>
                        <div>{ player.redTeam.barons }</div>
                        <div>{ player.redTeam.towers }</div>
                    </div>
                </div>
            </div>


        </nav>)
}


export default TeamCard;
